import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, isDoctor } from '../services/authService';
import { Container, Form, Button, Alert, Spinner } from 'react-bootstrap';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    async function handleSubmit(e) {
        e.preventDefault();
        setIsLoading(true);
        try {
            const authToken = await login(email, password);
            console.log(authToken);
            const doctorStatus = await isDoctor();
            if (doctorStatus) {
                navigate('/upload');
            } else {
                setError('Access denied. Doctor role required.');
            }
        } catch (err) {
            setError('Login failed. Please check your credentials.');
            console.log(err);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <Container className="mt-5">
            <div className="w-100" style={{ maxWidth: '400px', margin: '0 auto' }}>
                <h2 className="text-center mb-4">Serosight</h2>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="text"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Button variant="primary" type="submit" className="w-100" disabled={isLoading}>
                        {isLoading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2"
                                />
                                Logging in...
                            </>
                        ) : (
                            'Login'
                        )}
                    </Button>
                </Form>
            </div>
        </Container>
    );
}

export default Login; 